<template>
	<el-dialog title="提出建议" width="30%" center :visible="show" @close="close">
		<el-input type="textarea" :rows="2" placeholder="请输入内容" :autosize="{ minRows: 4, maxRows: 99 }" v-model="exerciseBook"></el-input>
		<div class="p_flex p_f_c p_m_t_30" @click="goButton"><el-button type="success">确认</el-button></div>
	</el-dialog>
</template>

<script>
export default {
	props:{
		show:null
	},
	data() {
		return {
			exerciseBook:'',
			job_record_id:''
		};
	},
	mounted() {
	},
	methods: {
		close() {
			this.$emit('closes', false);
		},
		goButton(id){
			if( this.exerciseBook == '' ){
				this.$message.error('请填写建议')
				return
			}
			this.$request.ajax(this).post("/api_teacher/wrong_question_proposal",{
				job_record_id:this.job_record_id,
				proposal:this.exerciseBook
			}).then(res=>{
				this.$message.success(res.msg)
			})
			this.$emit('goButton', false);
		},
		record(id){
			console.log(id)
			this.job_record_id = id
		},
	}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/homet/wrong/commponents/popUp.vue